import Request from "@/models/checkRequest/request";
import AppSettings from "@/appsettings";
export default class RequestService {
  static requests: Array<Request> = [];
  static AddRequest(
    url: string,
    selectedHttpMethod: string,
    selectedScheme: string
  ) {
    this.requests.push(new Request(url, selectedHttpMethod, selectedScheme));
  }
  static AddRequestsFromString(
    source: string,
    selectedHttpMethod: string,
    selectedScheme: string,
    hasActiveSubscription: boolean
  ) {
    let maximumUrlsPerBatch = AppSettings.MaximumRequestsPerBatch.Free;

    if (!hasActiveSubscription) {
      selectedScheme = "";
    }

    if (hasActiveSubscription) {
      maximumUrlsPerBatch = AppSettings.MaximumRequestsPerBatch.Premium;
    }

    // Split the urls to an array,
    // so we can handle each one properly
    // The list is split by the following delimiters:
    // - \s (newline)
    // - ,
    let urlArray = source.trim().split(/[\n,]+/);
    for (let x = 0; x < urlArray.length && x < maximumUrlsPerBatch; x++) {
      let url = urlArray[x];
      this.AddRequest(url, selectedHttpMethod, selectedScheme);
    }
  }
  static AddRequestsFromCsv(
    source: [],
    selectedColumn: string,
    selectedHttpMethod: string,
    selectedScheme: string,
    hasActiveSubscription: boolean
  ) {
    let maximumUrlsPerBatch = AppSettings.MaximumRequestsPerBatch.Free;

    if (!hasActiveSubscription) {
      selectedScheme = "";
    }

    if (hasActiveSubscription) {
      maximumUrlsPerBatch = AppSettings.MaximumRequestsPerBatch.Premium;
    }
    for (let i = 0; i < source.length && i < maximumUrlsPerBatch; ++i) {
      let url = source[i][selectedColumn];
      this.AddRequest(url, selectedHttpMethod, selectedScheme);
    }
  }
  /**
   * Returns all requests from the service and empties it afterwards.
   */
  static GetAndEmptyRequests(): Array<Request> {
    const localRequests: Array<Request> = this.requests;
    this.requests = [];
    return localRequests;
  }
  static GetFirstStatusCode(request: Request): number {
    if (request.results.length) {
      return request.results[0].statusCode;
    }

    return -1;
  }
  static RequestHasResults(
    request: Request,
    minStatusCode: number,
    maxStatusCode: number
  ): boolean {
    if (request.results.length) {
      const index = 0;
      return (
        request.results[index].statusCode >= minStatusCode &&
        request.results[index].statusCode < maxStatusCode
      );
    } else {
      return false;
    }
  }
}
